<script lang="ts" setup>
import { Statuses } from '@/@types/order'

defineProps<{ status: Statuses | string }>()
</script>

<template>
    <div class="flex-1 space-y-4">
        <div class="flex w-full items-center justify-around gap-2">
            <div class="flex w-full min-w-0 items-center gap-2.5 self-start overflow-hidden rounded-lg border border-slate-100 p-2 px-2.5 text-sm">
                <span :data-status="status" class="group relative flex size-2 flex-shrink-0">
                    <span
                        class="group-data-[status=pending]:bg-primary absolute inline-flex h-full w-full animate-ping rounded-full opacity-75 group-data-[status=canceled]:bg-red-500 group-data-[status=canceled\_by\_admin]:bg-red-500 group-data-[status=paid]:bg-green-500 group-data-[status=refunded]:bg-red-500 group-data-[status=released]:bg-yellow-200"
                    ></span>
                    <span
                        class="group-data-[status=pending]:bg-primary relative inline-flex size-2 rounded-full group-data-[status=canceled]:bg-red-500 group-data-[status=canceled\_by\_admin]:bg-red-500 group-data-[status=paid]:bg-green-500 group-data-[status=refunded]:bg-red-500 group-data-[status=released]:bg-yellow-200"
                    ></span>
                </span>
                <span class="line-clamp-1 min-w-0 overflow-hidden text-left text-ellipsis whitespace-pre-line">
                    {{ $t(status) }}
                </span>
            </div>
        </div>
    </div>
</template>
